import script from "./message-abstract-video.vue?vue&type=script&setup=true&lang=ts"
export * from "./message-abstract-video.vue?vue&type=script&setup=true&lang=ts"

import "./message-abstract-video.vue?vue&type=style&index=0&id=2897e42c&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2897e42c"]])

export default __exports__